import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["get", "set", "remove"] }] */
var LocalStorageMethod = /*#__PURE__*/function () {
  function LocalStorageMethod() {
    _classCallCheck(this, LocalStorageMethod);
  }
  return _createClass(LocalStorageMethod, [{
    key: "get",
    value: function get(key) {
      var item = localStorage.getItem(key);
      if (item) {
        return JSON.parse(item);
      }
      return {};
    }
  }, {
    key: "set",
    value: function set(key, item) {
      localStorage.setItem(key, JSON.stringify(item));
    }
  }, {
    key: "remove",
    value: function remove(key) {
      localStorage.removeItem(key);
    }
  }]);
}();
export { LocalStorageMethod as default };